var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDangerCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6663 7.9987C14.6663 4.3168 11.6816 1.33203 7.99967 1.33203C4.31778 1.33203 1.33301 4.3168 1.33301 7.9987C1.33301 11.6806 4.31778 14.6654 7.99967 14.6654C11.6816 14.6654 14.6663 11.6806 14.6663 7.9987ZM7.99967 4.16536C8.27582 4.16536 8.49967 4.38922 8.49967 4.66536V8.66536C8.49967 8.94151 8.27582 9.16536 7.99967 9.16536C7.72353 9.16536 7.49967 8.94151 7.49967 8.66536V4.66536C7.49967 4.38922 7.72353 4.16536 7.99967 4.16536ZM7.99967 11.332C8.36786 11.332 8.66634 11.0336 8.66634 10.6654C8.66634 10.2972 8.36786 9.9987 7.99967 9.9987C7.63148 9.9987 7.33301 10.2972 7.33301 10.6654C7.33301 11.0336 7.63148 11.332 7.99967 11.332Z",
    fill: "#FE646F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDangerCircle);
export default __webpack_public_path__ + "static/media/icon_danger_circle.fff89417f35f82504adf63952733a700.svg";
export { ForwardRef as ReactComponent };